import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type {
  BookingEmailTemplatesListResponseData,
  BookingServicesSearchResponseData,
  ListQueryParams,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const BOOKING_EMAIL_TEMPLATES_LIST_QUERY_KEY =
  'booking_email_templates_list';

export const BOOKING_SERVICES_SEARCH_QUERY_KEY = 'booking_services_search';

export const useBookingEmailTemplatesListQuery = (
  url: string,
  queryParams: ListQueryParams,
) =>
  useQuery({
    queryKey: [BOOKING_EMAIL_TEMPLATES_LIST_QUERY_KEY, url, queryParams],
    queryFn: () =>
      HttpClient.request<BookingEmailTemplatesListResponseData>({
        method: 'GET',
        url,
        params: queryParams,
      }),
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });

export const useBookingServicesSearchQuery = (url: string, search: string) =>
  useQuery({
    queryKey: [BOOKING_SERVICES_SEARCH_QUERY_KEY, url, search],
    queryFn: () =>
      HttpClient.request<BookingServicesSearchResponseData>({
        method: 'GET',
        url,
        params: {
          size_per_page: 100,
          sort_column: 'created_at',
          sort_direction: 'desc',
          search: {
            value: search,
          },
        },
      }),
    refetchOnWindowFocus: false,
  });
